import React from 'react';

import { MdOutlineCheckCircleOutline, MdClose } from 'react-icons/md';

import * as Style from './styles';

function ContentModalActiveFaturaDigital({ closeModal }) {
  return (
    <Style.WrapperHeaderSituacao>
      <div className="modal-active-fatura">
        <div className="modal-active-fatura__left">
          <div className="modal-active-fatura__alert">
            <MdOutlineCheckCircleOutline />
          </div>

          <div className="modal-active-fatura__text">
            <p>Fatura digital por e-mail ativada</p>
            <span>
              A fatura por e-mail foi ativada com sucesso para este e-mail
            </span>
          </div>
        </div>
        <div className="modal-active-fatura__right">
          <MdClose onClick={() => closeModal()} />
        </div>
      </div>
    </Style.WrapperHeaderSituacao>
  );
}

export default ContentModalActiveFaturaDigital;
